import App from './App.svelte';
import wasm from '../../wasm/Cargo.toml';
const init = async () => {
    let core = await wasm();
    new App({
        target: document.body,
        props: {
            core: core,
        },
    });
};
init();
